// Inbox cleanup (Phase F). "Close" moves a conversation out of the active inbox
// without deleting anything; "Reopen" brings it back. A new customer message
// reopens it automatically on the server.

export const STATUS_FILTERS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Closed' },
  { value: 'all', label: 'All' }
];
export const MAX_BULK = 100;
const INACTIVE = ['closed', 'archived'];

export const isInactiveStatus = (status) => INACTIVE.includes(status);

export function matchesStatusFilter(status, filter = 'active') {
  const value = status || 'open';
  if (filter === 'all') return true;
  if (filter === 'inactive') return isInactiveStatus(value);
  return !isInactiveStatus(value);
}

// Applies status changes to the loaded list: rows that no longer match the
// current filter leave it, the others get the new status.
export function patchStatuses(rows, updates, filter) {
  const byId = new Map(updates.map((update) => [String(update.id), update.status]));
  return (Array.isArray(rows) ? rows : []).flatMap((row) => {
    if (!byId.has(String(row.id))) return [row];
    const status = byId.get(String(row.id));
    return matchesStatusFilter(status, filter) ? [{ ...row, status }] : [];
  });
}

export function bulkSummaryMessage(action, totals) {
  const done = action === 'close' ? 'closed' : 'reopened';
  const parts = [`${totals.updated} ${done}`];
  if (totals.skipped) parts.push(`${totals.skipped} skipped`);
  if (totals.failed) parts.push(`${totals.failed} failed`);
  return `${parts.join(', ')}.`;
}

export const SKIP_REASONS = {
  already_closed: 'already closed',
  already_open: 'already open',
  new_activity: 'a new message arrived',
  changed: 'changed by someone else'
};

export const closeConfirmation = (count = 1) => (count === 1
  ? 'Close this conversation? It leaves the active inbox. Messages and customer records are kept, and a new customer message reopens it.'
  : `Close ${count} selected conversations? They leave the active inbox. Messages and customer records are kept, and a new customer message reopens a conversation.`);
